export const FETCH_ACCOUNT = 'fetch/account'
export const SET_ERROR_ACCOUNT = 'set/error/account'
